export const affiliateGettingStartedArticle = {
  title: 'Affiliate Marketing Engine: Getting Started',
  slug: 'affiliate-marketing-getting-started',
  content: `Affiliate Marketing Engine: Getting Started

Set up an affiliate program and manage partners, payouts, and reporting.

1) Open affiliate management
- Go to /marketing/affiliate-management.
- If no program exists, click “Create Program”.

2) Configure programs and plans
- Use Programs and Plans tabs to define commission rules.
- Tiers, approvals, and attribution settings unlock once a program exists.

3) Recruit affiliates
- Use Affiliates and Signup Form to onboard partners.
- Review approvals in the Approvals tab.

4) Track payouts and reporting
- Payouts and Reports summarize earnings and conversions.
`,
};
